import { Mail, Mailbox, PhoneCall } from 'lucide-react';
import React, { useMemo } from 'react';
import { Badge } from 'components/ui/badge';
import { cn } from 'library/utils';

/**
 *
 * @param {Object} props
 * @param {"VOICE" | "SMS" | "SMS2" | "MMS" | "RVM"} props.messageType
 * @param {string} props.className
 * @returns
 */
const BadgeCampaign = ({ messageType, className }) => {
  //! State

  //! Function

  //! Render
  const mappingClassNameByType = useMemo(() => {
    return {
      VOICE: 'tw-bg-green-100 tw-border-green-500',
      SMS: 'tw-bg-yellow-100 tw-border-yellow-500',
      SMS2: 'tw-bg-yellow-100 tw-border-yellow-500',
      EMAIL: 'tw-bg-yellow-100 tw-border-yellow-500',
      MMS: 'tw-bg-blue-100 tw-border-blue-500',
      RVM: 'tw-border-teal-900',
    };
  }, []);

  const mappingIconByType = useMemo(() => {
    return {
      VOICE: <PhoneCall size={16} />,
      SMS: <Mail size={16} />,
      SMS2: <Mail size={16} />,
      EMAIL: <Mail size={16} />,
      MMS: <Mail size={16} />,
      RVM: <Mailbox size={16} />,
    };
  }, []);

  if (!messageType) {
    return null;
  }

  return (
    <Badge
      className={cn(
        `${mappingClassNameByType?.[messageType] || 'tw-border-sky-900'} tw-h-7 dark:tw-text-black`,
        className,
      )}
      variant='outline'
    >
      <span className='tw-inline-block tw-mr-[6px]'>{mappingIconByType?.[messageType] || ''}</span>
      {messageType}
    </Badge>
  );
};

export default BadgeCampaign;
